import { type PollsDataSource } from '../../data/polls.datasource'

export class ClosePollInteractor {
  constructor(private readonly dataSource: PollsDataSource) {}

  async execute(postId: number): Promise<void> {
    await this.dataSource.close(postId)
  }
}
